// extracted by mini-css-extract-plugin
module.exports = {"loading_container":"PageLoader_loading_container__dQNM5","ball_clip_rotate":"PageLoader_ball_clip_rotate__IXmhI","rotate":"PageLoader_rotate__7ZU1i"};